import { Component } from '@angular/core';
import {ImportToNewSavedCartFormComponent} from "@spartacus/cart/import-export/components";

@Component({
  selector: 'cx-import-to-new-saved-cart-form',
  standalone: false,
  templateUrl: './gonvarri-import-to-new-saved-cart-form.component.html',
  styleUrl: './gonvarri-import-to-new-saved-cart-form.component.scss'
})
export class GonvarriImportToNewSavedCartFormComponent extends ImportToNewSavedCartFormComponent {

  getFormControl(data: any): any {
    return data;
  }

}
